import React, { useState } from 'react';
import { Box, IconButton, TextField, Tooltip, InputAdornment, Menu, MenuItem } from '@mui/material';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import AddIcon from '@mui/icons-material/Add';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import BoltIcon from '@mui/icons-material/Bolt';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import EmojiPicker from '../../../../components/emoji-picker';
import AudioRecorder from '../chat/audio/audio-recorder';
import '../chat/styles.css';

// GRUPO — composer ESPELHADO do send-bar 1:1 (mesmas classes CSS + emoji + anexo + resposta rapida
// + audio + enviar). FASE MOCK: envio/anexo/audio so dao feedback local; sem chamada de backend.
function GroupSendBar(props) {
  const { intl, disabled, onSend, onMock } = props;
  const [message, setMessage] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMore = Boolean(anchorEl);

  const emoji = (obj) => setMessage((m) => m + obj.emoji);
  const send = () => {
    const text = message.trim();
    if (!text || disabled) return;
    onSend(text);
    setMessage('');
  };
  const onFile = (e) => {
    const f = e.target.files && e.target.files[0];
    if (f && onMock) onMock(intl.formatMessage({ id: 'groupconv.mock.attach' }, { name: f.name }));
    e.target.value = '';
  };

  return (
    <div className="omnichannel-chat-message">
      <Box className="omnichannel-chat-send-bar-row">
        <Box className="omnichannel-chat-send-bar-input">
          <TextField
            fullWidth
            disabled={disabled}
            label=""
            inputProps={{ maxLength: 255 }}
            autoComplete="off"
            variant="outlined"
            name="searchGroupChat"
            placeholder={intl.formatMessage({ id: 'groupconv.placeholder' })}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                  <EmojiPicker onEmojiClick={emoji} button={<SentimentSatisfiedAltIcon sx={{ color: '#FFF' }} />} />
                  <Tooltip title={intl.formatMessage({ id: 'groupconv.more' })}>
                    <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} size="small"
                      sx={{ transition: 'transform 0.3s ease-in-out', transform: openMore ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <AddIcon sx={{ color: '#FFF' }} />
                    </IconButton>
                  </Tooltip>
                  <Menu anchorEl={anchorEl} open={openMore} onClose={() => setAnchorEl(null)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }} transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
                    <MenuItem onClick={() => { setAnchorEl(null); onMock && onMock(intl.formatMessage({ id: 'groupconv.mock.quick' })); }}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <BoltIcon sx={{ color: '#FFD700' }} />
                      <span>{intl.formatMessage({ id: 'groupconv.quickmsgs' })}</span>
                    </MenuItem>
                  </Menu>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="start" sx={{ cursor: 'pointer' }}>
                  <label htmlFor="group-attachment-input">
                    <IconButton component="span" disabled={disabled}>
                      <AttachFileIcon sx={{ color: '#FFF', transform: 'rotate(40deg)' }} />
                    </IconButton>
                    <input id="group-attachment-input" type="file" style={{ display: 'none' }} onChange={onFile} multiple />
                  </label>
                </InputAdornment>
              ),
            }} />
        </Box>

        <Box className="omnichannel-chat-send-bar-actions">
          <AudioRecorder onSendAudio={() => onMock && onMock(intl.formatMessage({ id: 'groupconv.mock.audio' }))} maxDuration={120} />
          <IconButton aria-label={intl.formatMessage({ id: 'groupconv.send' })} onClick={send}
            sx={{ flex: '0 0 40px', width: 40, height: 40 }}>
            <SendOutlinedIcon sx={{ color: 'var(--mexx-green-primary, #8BC34A)' }} />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
}

export default GroupSendBar;
